








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PdfLink extends Vue {
  @Prop({ default: 0 })
  public attachId!: number
  @Prop({ default: '' })
  public attachGuid!: string
  @Prop({ default: '' })
  public attachName!: string
  @Prop({ default: '' })

  public viewPdf() {
    var data = {
      id: this.attachId,
      guid: this.attachGuid,
      name: this.attachName
    }
    window.eventBus.$emit('pdfViewer', data)
    return false
  }
}
